// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".85dab87a378a6bdb06a261a32d53cd1c6f52bfd5.chunk.js";
};